module.exports = __webpack_public_path__ + "6c439bf00ab369fcf417fc8cae1a2006.png";